// import React from 'react'
// import { Link, useLocation } from 'react-router-dom'
// import { useEffect, useContext } from 'react'
// import { SocketContext } from '../context/SocketContext'
// import { useNavigate } from 'react-router-dom'
// import 'remixicon/fonts/remixicon.css'
// import LiveTracking from '../components/LiveTracking'
// import axios from 'axios'

// const Riding = () => {
//     const location = useLocation()
//     const { ride } = location.state || {}
//     const { socket } = useContext(SocketContext)
//     const navigate = useNavigate()

//     useEffect(() => {
//         if (!socket) return;

//         socket.on("ride-ended", () => {
//             navigate('/home')
//         })
//     }, [socket])

//     const makePayment = () => {
//         const loadScript = (src) => {
//             return new Promise((resolve) => {
//                 const script = document.createElement("script");
//                 script.src = src;
//                 script.onload = () => resolve(true);
//                 script.onerror = () => resolve(false);
//                 document.body.appendChild(script);
//             });
//         };

//         const handlePayment = async () => {
//             const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

//             if (!res) {
//                 alert("Razorpay SDK failed to load. Are you online?");
//                 return;
//             }

//             try {
//                 const options = {
//                     key: import.meta.env.VITE_RAZORPAY_KEY_ID || "rzp_test_STQ0QZwBcFRfOZ",
//                     amount: Math.round((ride?.fare || 1) * 100),
//                     currency: "INR",
//                     name: "Adarsh-Uber",
//                     description: "Ride Fare Payment",
//                     handler: function (response) {
//                         alert("Payment Successful! Payment ID: " + response.razorpay_payment_id);
//                         // navigate('/home')
//                     },
//                     prefill: {
//                         name: "User Default",
//                         contact: "9999999999"
//                     },
//                     theme: {
//                         color: "#16a34a"
//                     }
//                 };

//                 const paymentObject = new window.Razorpay(options);
//                 paymentObject.on('payment.failed', function (response) {
//                     alert("Payment Failed: " + response.error.description);
//                 });
//                 paymentObject.open();

//             } catch (error) {
//                 console.error("Error creating payment:", error);
//                 alert("Could not start payment. Please try again.");
//             }
//         };

//         handlePayment();
//     }


//     return (
//         <div className='h-screen'>
//             <button
//                 onClick={() => navigate(-1)}
//                 className='absolute left-4 top-6 z-20 bg-white p-2 rounded-full shadow'
//             >
//                 <i className="ri-arrow-left-line text-2xl"></i>
//             </button>
//             <Link to='/home' className='fixed right-2 top-2 h-10 w-10 bg-white flex items-center justify-center rounded-full'>
//                 <i className="text-lg font-medium ri-home-5-line"></i>
//             </Link>
//             <div className='h-1/2'>
//                 <LiveTracking />

//             </div>
//             <div className='h-1/2 p-4'>
//                 <div className='flex items-center justify-between'>
//                     <img className='h-12' src="https://swyft.pl/wp-content/uploads/2023/05/how-many-people-can-a-uberx-take.jpg" alt="" />
//                     <div className='text-right'>
//                         <h2 className='text-lg font-medium capitalize'>{ride?.captain.fullname.firstname}</h2>
//                         <h4 className='text-xl font-semibold -mt-1 -mb-1'>{ride?.captain.vehicle.plate}</h4>
//                         <p className='text-sm text-gray-600'>Maruti Suzuki Alto</p>

//                     </div>
//                 </div>

//                 <div className='flex gap-2 justify-between flex-col items-center'>
//                     <div className='w-full mt-5'>

//                         <div className='flex items-center gap-5 p-3 border-b-2'>
//                             <i className="text-lg ri-map-pin-2-fill"></i>
//                             <div>
//                                 <h3 className='text-lg font-medium'>562/11-A</h3>
//                                 <p className='text-sm -mt-1 text-gray-600'>{ride?.destination}</p>
//                             </div>
//                         </div>
//                         <div className='flex items-center gap-5 p-3'>
//                             <i className="ri-currency-line"></i>
//                             <div>
//                                 <h3 className='text-lg font-medium'>₹{ride?.fare} </h3>
//                                 <p className='text-sm -mt-1 text-gray-600'>Cash Cash</p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <button onClick={makePayment} className='w-full mt-5 bg-green-600 text-white font-semibold p-2 rounded-lg'>Make a Payment</button>
//             </div>
//         </div>
//     )
// }

// export default Riding



import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useEffect, useContext, useState } from 'react'
import { SocketContext } from '../context/SocketContext'
import { useNavigate } from 'react-router-dom'
import 'remixicon/fonts/remixicon.css'
import LiveTracking from '../components/LiveTracking'
import axios from 'axios'

const Riding = () => {
    const location = useLocation()
    const { ride } = location.state || {}
    const { socket } = useContext(SocketContext)
    const navigate = useNavigate()
    const [rideStarted, setRideStarted] = useState(false)
    const [paymentCompleted, setPaymentCompleted] = useState(false)

    useEffect(() => {
        if (!socket) return;

        // Listen for ride started event
        socket.on("ride-started", (data) => {
            console.log("Ride started:", data);
            setRideStarted(true);
        });

        socket.on("ride-ended", () => {
            console.log("Ride ended");
            alert("Ride completed! Thank you for riding with us.");
            navigate('/home')
        });

        return () => {
            socket.off("ride-started");
            socket.off("ride-ended");
        };
    }, [socket, navigate]);

    const makePayment = () => {
        const loadScript = (src) => {
            return new Promise((resolve) => {
                const script = document.createElement("script");
                script.src = src;
                script.onload = () => resolve(true);
                script.onerror = () => resolve(false);
                document.body.appendChild(script);
            });
        };

        const handlePayment = async () => {
            const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

            if (!res) {
                alert("Razorpay SDK failed to load. Are you online?");
                return;
            }

            try {
                const options = {
                    key: import.meta.env.VITE_RAZORPAY_KEY_ID || "rzp_test_STQ0QZwBcFRfOZ",
                    amount: Math.round((ride?.fare || 1) * 100),
                    currency: "INR",
                    name: "Adarsh-Uber",
                    description: "Ride Fare Payment",
                    handler: function (response) {
                        alert("Payment Successful! Payment ID: " + response.razorpay_payment_id);
                        setPaymentCompleted(true);
                        // Stay on page, captain will finish the ride
                    },
                    prefill: {
                        name: ride?.user?.fullname?.firstname || "User",
                        contact: "9999999999"
                    },
                    theme: {
                        color: "#16a34a"
                    }
                };

                const paymentObject = new window.Razorpay(options);
                paymentObject.on('payment.failed', function (response) {
                    alert("Payment Failed: " + response.error.description);
                });
                paymentObject.open();

            } catch (error) {
                console.error("Error creating payment:", error);
                alert("Could not start payment. Please try again.");
            }
        };

        handlePayment();
    }

    const captainFirstName = ride?.captain?.fullname?.firstname || 'Captain'
    const vehiclePlate = ride?.captain?.vehicle?.plate || 'XXXX-XXXX'
    const destination = ride?.destination || 'Destination'
    const fare = ride?.fare || 0
    const pickup = ride?.pickup || 'Pickup location'

    return (
        <div className='h-screen'>
            <button
                onClick={() => navigate(-1)}
                className='absolute left-4 top-6 z-20 bg-white p-2 rounded-full shadow'
            >
                <i className="ri-arrow-left-line text-2xl"></i>
            </button>
            <Link to='/home' className='fixed right-2 top-2 h-10 w-10 bg-white flex items-center justify-center rounded-full'>
                <i className="text-lg font-medium ri-home-5-line"></i>
            </Link>
            <div className='h-1/2'>
                <LiveTracking />
            </div>
            <div className='h-1/2 p-4'>
                <div className={`p-2 rounded-lg mb-3 text-center text-sm font-semibold ${rideStarted ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
                    {rideStarted ? '✅ RIDE IN PROGRESS' : '⏳ WAITING FOR CAPTAIN'}
                </div>

                <div className='flex items-center justify-between'>
                    <img className='h-12' src="https://swyft.pl/wp-content/uploads/2023/05/how-many-people-can-a-uberx-take.jpg" alt="" />
                    <div className='text-right'>
                        <h2 className='text-lg font-medium capitalize'>{captainFirstName}</h2>
                        <h4 className='text-xl font-semibold -mt-1 -mb-1'>{vehiclePlate}</h4>
                        <p className='text-sm text-gray-600'>Maruti Suzuki Alto</p>
                    </div>
                </div>

                <div className='flex gap-2 justify-between flex-col items-center'>
                    <div className='w-full mt-5'>
                        <div className='flex items-center gap-5 p-3 border-b-2'>
                            <i className="text-lg ri-map-pin-user-fill"></i>
                            <div>
                                <h3 className='text-lg font-medium'>Pickup</h3>
                                <p className='text-sm -mt-1 text-gray-600'>{pickup}</p>
                            </div>
                        </div>
                        <div className='flex items-center gap-5 p-3 border-b-2'>
                            <i className="text-lg ri-map-pin-2-fill"></i>
                            <div>
                                <h3 className='text-lg font-medium'>Destination</h3>
                                <p className='text-sm -mt-1 text-gray-600'>{destination}</p>
                            </div>
                        </div>
                        <div className='flex items-center gap-5 p-3'>
                            <i className="ri-currency-line"></i>
                            <div>
                                <h3 className='text-lg font-medium'>₹{fare}</h3>
                                <p className='text-sm -mt-1 text-gray-600'>Cash</p>
                            </div>
                        </div>
                    </div>
                </div>

                {ride?.otp && !rideStarted && (
                    <div className='mt-3 p-2 bg-yellow-50 rounded-lg text-center'>
                        <p className='text-sm'>OTP: <span className='font-bold'>{ride.otp}</span></p>
                    </div>
                )}

                {paymentCompleted ? (
                    <div className='w-full mt-5 text-center text-green-600 py-2 bg-green-50 rounded-lg'>
                        ✅ Payment completed! Waiting for captain to finish the ride...
                    </div>
                ) : rideStarted ? (
                    <button onClick={makePayment} className='w-full mt-5 bg-green-600 text-white font-semibold p-2 rounded-lg'>
                        Complete Ride & Pay ₹{fare}
                    </button>
                ) : (
                    <div className='w-full mt-5 text-center text-gray-500 py-2 bg-gray-100 rounded-lg'>
                        ⏳ Waiting for captain to start...
                    </div>
                )}
            </div>
        </div>
    )
}

export default Riding